export enum AiPerformanceCardTitles {
  RESPONSES_PER_CALL = 'Average Number of Responses per Call by AI',
  AI_HANDLING_TIME = 'Average AI Handling Time',
  RESPONSE_TIME = 'Average response time',
}

export const ARROW_COLOR_GREEN = '#0cc1af';
